export const strings = {
  appTitle: 'Twisted Tabby\'s Fallout 76 Tools',
  general: {
    home: 'Home',
  },
  categories: {
    food: 'Food',
    chems: 'Chems'
  },
  filters: {
    title: 'Filters',
    category: 'Category',
    buffCategory: 'Buff Category',
    type: 'Type',
    clearAll: 'Clear All',
    apply: 'Apply Filters'
  },
  special: {
    strength: 'Strength',
    perception: 'Perception',
    endurance: 'Endurance',
    charisma: 'Charisma',
    intelligence: 'Intelligence',
    agility: 'Agility',
    luck: 'Luck',
    acronym: 'S.P.E.C.I.A.L.'
  },
  gatheringList: {
    title: 'List',
    viewOptions: {
      allCategories: 'All Categories',
      specificCategory: 'Specific Category',
      allTypes: 'All Types',
      specificType: 'Specific Type'
    },
    empty: 'No recipes selected',
    totalIngredients: 'Total Ingredients Needed',
    addRecipe: 'Add to Gathering List',
    removeRecipe: 'Remove from Gathering List',
    clearList: 'Clear List'
  },
  recipes: {
    title: 'Recipes',
    filterByCategory: 'Filter by Category',
    filterByBuffCategory: 'Filter by Buff Category',
    filterByType: 'Filter by Type',
    clearAllFilters: 'Clear All Filters'
  },
  recipe: {
    ingredients: 'Ingredients',
    buffs: 'Buffs',
    types: 'Types',
    category: 'Category',
    duration: 'Duration',
    quantity: 'Quantity'
  },
  importRecipe: {
    title: 'Import Recipe',
    pasteRecipeJSON: 'Paste your recipe JSON here',
    import: 'Import',
    invalidJSON: 'Invalid JSON',
    error: 'Error',
    success: 'Recipe imported successfully'
  },
  charismaPriceCalc: {
    title: 'Charisma to Price Calculator',
    shortTitle: 'NPC Vendor Pricing', // For navigation
    sourceCredits: 'Data sourced from The DuchessFlame',
    sourceLink: 'https://www.theduchessflame.com/post/charisma-and-barter-prices-how-it-works-in-fallout-76',
    sourceDate: 'Data updated on 2025-02-19'
  },
}; 